import { gql } from "@apollo/client";

export const GET_PAYMENT_METHODS = gql`
	query GetPaymentMethods {
		customerPaymentMethods(first: 1) {
			nodes {
				id
				card {
					brand
					nameOnCard
					last4
					expMonth
					expYear
				}
			}
		}
	}
`;
